import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// Fallback polling for check job completion.
// Turbo Streams via solid_cable can occasionally miss the final broadcast;
// this controller detects completion server-side and reloads the page.
export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 3000 }
  }

  connect() {
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  async poll() {
    try {
      const resp = await fetch(this.urlValue)
      if (!resp.ok) return
      const { status } = await resp.json()
      if (status === "completed" || status === "failed") {
        clearInterval(this.timer)
        this.timer = null
        Turbo.visit(window.location.href, { action: "replace" })
      }
    } catch (_) {
      // ignore transient network errors
    }
  }
}
